// userSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getCurrentUser } from "./services/authService";

export const fetchCurrentUser = createAsyncThunk(
  "user/fetchCurrentUser",
  async (_, thunkAPI) => {
    try {
      const u = await getCurrentUser();
      return u; 
    } catch (err) {
      return null; // means not logged in or 401
    }
  }
);

/* short English comments only */
const userSlice = createSlice({
  name: "user",
  initialState: {
    user: undefined, 
    status: "idle" 
  },
  reducers: {
    setUser(state, action) {
      state.user = action.payload;
      if (action.payload) {
        state.status = "success";
      } else {
        state.status = "success";
      }
    },
    clearUser(state) {
      state.user = null;
      state.status = "success";
    },
    updateOrganizationLogo(state, action) {
      if (state.user && state.user.organization) {
        state.user.organization.logo = action.payload;
      }
    },
    updateOrganizationTimezone(state, action) {
      if (state.user && state.user.organization) {
        state.user.organization.timeZone = action.payload;
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCurrentUser.pending, (state) => {
        state.status = "loading";
        state.user = undefined;
      })
      .addCase(fetchCurrentUser.fulfilled, (state, action) => {
        state.user = action.payload; // might be object or null
        state.status = "success";
      })
      .addCase(fetchCurrentUser.rejected, (state) => {
        state.user = null;
        state.status = "success";
      });
  }
});

export const { setUser, clearUser, updateOrganizationLogo, updateOrganizationTimezone } = userSlice.actions;
export default userSlice.reducer;
